import { isEqual } from "lodash";
import moment from "moment";
import { getState } from "@/helpers/kisHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "KisDefectList",
  props: ["defects", "defectCount", "isLoading", "defectCategories"],
  data: () => ({
    headers: [
      { text: "Vorschau", value: "preview", sortable: false },
      { text: "Kategorie", value: "category" },
      { text: "Nachname Melder", value: "lastName" },
      { text: "Verantwortliche Person", value: "responsiblePersons" },
      { text: "Bearbeitungsstatus", value: "state" },
      { text: "Erstellt am", value: "createdAt" },
      { text: "Zuletzt geändert", value: "updatedAt" },
      { text: "Aktionen", value: "actions", sortable: false, align: "center" }
    ],
    statusItem: {},
    filter: { limit: 10, skip: 0 },
    itemsPerPage: 10
  }),
  async mounted() {
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    this.tableOptions.itemsPerPage = this.itemsPerPage ?? 10;
    await this.$store.dispatch("getAllUsers", {
      principal_id: this.currentPrincipal
    });
  },
  methods: {
    getState,
    async previousPage() {
      const limit = this.filter.limit || this.itemsPerPage;

      const { skip = 0 } = this.filter;
      const currentPage = Math.floor(skip / limit) + 1;

      if (currentPage > 1) {
        this.filter.skip = skip - limit;
        this.$emit("getItems", { ...this.filter });
      }
    },
    async nextPage() {
      const limit = this.filter.limit || this.itemsPerPage;

      const totalPages = Math.ceil(this.defectCount / limit);
      const { skip = 0 } = this.filter;
      const currentPage = Math.floor(skip / limit) + 1;

      if (currentPage < totalPages) {
        this.filter.skip = skip + limit;
        this.$emit("getItems", { ...this.filter });
      }
    },
    updateItemsPerPage(value) {
      this.$emit("setFilterLimit", value);
    },
    triggerFilter(options = {}) {
      const nextItemsPerPage = Number(options.itemsPerPage);
      const resolvedItemsPerPage =
        Number.isFinite(nextItemsPerPage) && nextItemsPerPage > 0
          ? nextItemsPerPage
          : this.itemsPerPage;
      const nextPage = Number(options.page);
      const resolvedPage =
        Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1;
      const skip =
        resolvedPage > 1 ? (resolvedPage - 1) * resolvedItemsPerPage : 0;

      const sortBy = Array.isArray(options.sortBy) ? options.sortBy : [];
      const sortDesc = Array.isArray(options.sortDesc) ? options.sortDesc : [];
      const sort = sortBy[0] || this.filter.sort || "createdAt";
      const direction = sortDesc[0] ? "desc" : "asc";

      const hasChanged =
        resolvedPage !== this.filter.page ||
        resolvedItemsPerPage !== this.filter.limit ||
        skip !== this.filter.skip ||
        sort !== this.filter.sort ||
        direction !== this.filter.direction;

      if (!hasChanged) return;

      this.itemsPerPage = resolvedItemsPerPage;
      this.filter = {
        ...this.filter,
        limit: resolvedItemsPerPage,
        itemsPerPage: resolvedItemsPerPage,
        page: resolvedPage,
        skip,
        sort,
        direction
      };

      this.$emit("setFilterPage", resolvedPage);
      this.$emit("getItems", { ...this.filter });
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    getCategory(category) {
      return (
        this.defectCategories?.find(cat => cat._id === category)?.title ?? ""
      );
    },
    getResponsiblePersons(persons) {
      let mappedPersons = persons
        .map(_person => this.persons.find(p => _person === p._id))
        ?.filter(p => !!p);

      mappedPersons = mappedPersons.map(person => {
        return `${person?.first_name} ${person?.last_name}`;
      });
      return mappedPersons.join(", ");
    },
    statusOpen(item) {
      this.statusItem = Object.assign({}, item);
    },
    async updateStatus() {
      const confirmRes = await this.$confirm(
        `Der Status wurde möglicherweise geändert. Möchten Sie eine Update E-Mail an den Melder senden?`,
        {
          ...confirmWarningConfig,
          buttonTrueText: "Ja",
          buttonFalseText: "Nein"
        }
      );
      this.statusItem.preventUpdateMail = !confirmRes;
      await this.saveDefect(this.statusItem);
    },
    async saveDefect(item) {
      const headers = getTokenHeader();
      const response = await axios.put(
        `${env.kis_api_client_url}defect/${item._id}`,
        item,
        {
          headers
        }
      );
      if (response.status === 200) {
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
        await this.$store.dispatch("getDefects", this.filter);
      } else {
        await this.$store.dispatch(
          "createError",
          "Es ist ein unerwarteter Fehler aufgetreten"
        );
      }
    }
  },
  computed: {
    tableOptions: {
      get() {
        // eslint-disable-next-line no-unused-vars
        const { name, ...filter } = this.filter;
        return filter;
      },
      set(value) {
        if (!this.filter.isDefault) delete value.isDefault;
        if (isEqual(this.filter, value)) return;
        this.triggerFilter(value);
      }
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    persons() {
      return (
        this.$store.state.users
          ?.filter(
            user =>
              !!user.roles.find(
                role =>
                  role.category.id === "00000000-0000-0000-0000-119000000000"
              ) && user.principal_id === this.currentPrincipal
          )
          ?.map(user => ({
            ...user,
            title: `${user.first_name} ${user.last_name}`
          })) || []
      );
    }
  }
};
